import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { $t } from "~/i18n.js";

import { Flex } from "antd";
import { MainLayout } from "../../components/layout/layout.jsx";

import { RefreshBaseData } from "~/components/buttons/RefreshBaseData.jsx";
import { useSyncData } from "~/compositions/state.js";
import { updateIfNeeded } from "~/lib/helpers.js";
import { getFlightStats } from "~/redux/flights/flights.actions.js";
import { getVliegerData } from "~/redux/persist/persist.actions.js";
import { DataCard } from "../../components/dataCards/dataCard.jsx";
import { BreadcrumbHeader } from "../../components/layout/breadcrumbHeader.jsx";
import { VliegerStats } from "../../components/profile/vliegerStats.jsx";
import { CardInstructeursboek } from "./cards/card.instructeursboek.jsx";
import { Card } from "antd";

export const MyInstructorBook = ({ history }) => {
  const dispatch = useDispatch();
  const persist = useSelector((state) => state.persist);
  const bevoegdheden = useSelector((state) => state.flights.bevoegdheden);

  const vlieger_data = persist.vlieger_data
    ? persist.vlieger_data
    : { gegevens: {} };

  const vliegendLid = persist?.profile?.vliegt;

  const { updateBaseIfRequired } = useSyncData();

  useEffect(() => {
    updateBaseIfRequired();
    updateIfNeeded(persist.lastUpdatedData, async () => {
      dispatch(getVliegerData());
    });
  }, [dispatch]);

  return (
    <MainLayout
      history={history}
      isLoading={persist.isPending || !persist.lastUpdatedData}
    >
      <div className="row" style={{ justifyContent: "space-between" }}>
        <BreadcrumbHeader breadcrumbs={[$t("Instructieboek")]} />
      </div>

      <Flex gap={24}>
        <div
          style={{ background: "white", padding: "3px 12px", borderRadius: 3 }}
        >
          <CardInstructeursboek
            notities={vlieger_data.notities}
            pilot={persist.profile}
            behaalde_bevoegdheden={vlieger_data.behaalde_bevoegdheden}
            dto_training={vlieger_data.dto_training}
            bevoegdheden={bevoegdheden}
          />
        </div>
      </Flex>
    </MainLayout>
  );
};
